<div class="notifications-container" appendToBody>
  @for (notification of notifications; track notification.uuid) {
    <div class="hc-notification" [ngClass]="{
      'is-success': notification.type === NotificationType.SUCCESS,
      'is-error': notification.type === NotificationType.ERROR,
      'is-warning': notification.type === NotificationType.WARNING,
      'is-info': notification.type === NotificationType.INFO
    }">
      <div class="hc-notification-icon">
        <mat-icon>{{ getIcon(notification.type) }}</mat-icon>
      </div>
      <div class="hc-notification-content">
        <div class="hc-notification-title">{{ getTitle(notification.type) | translate }}</div>
        <div class="hc-notification-message">{{ notification.message | translate }}</div>
        @if (notification.details?.length) {
          <ul class="hc-notification-details">
            @for (detail of notification.details; track $index) {
              <li>
                @if (detail.label) {
                  {{ detail.key | translate: { field: (detail.label | translate) } }}
                } @else {
                  {{ detail.key | translate }}
                }
              </li>
            }
          </ul>
        }
      </div>
      @if (!notification.locked) {
        <button class="hc-notification-close" (click)="closeNotification(notification)">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  }
</div>